import { extractDateAndTimeFromTimestamp } from "../../shared/utilities";
import { useLanguage } from "../../context/LanguageContext.js";
import './DayBreak.css';

const DayBreak = ({ timestamp, first = false }) => {
  const { language } = useLanguage();
  const [date] = extractDateAndTimeFromTimestamp(timestamp, language);
  return (
    <div className={`day-break ${first ? 'first' : ''}`}>
      <span className="day-break-label">{date}</span>
    </div>
  );
}

export default DayBreak;
